/* SEW Markaz - mobile sticky add to cart bar

   Oct 2026: the bar is a plain Add to cart again (it used to open the COD form).
   The COD form stays on the product page button and on the cart Checkout
   button, so Add to cart -> Checkout still ends in the COD form, and shoppers
   can build a 3-item basket for the 5% discount.

   The bar proxies a click to the real Add to cart button, so Dawn's cart
   drawer, variant state, quantity and error handling all keep working
   untouched. Price, availability, the selected variant's name and its image
   are mirrored from the buy box, so the two can never disagree.

   Visibility is driven by getBoundingClientRect on scroll rather than
   IntersectionObserver: Dawn replaces the buy-box markup on every variant
   change, which silently detaches an observed node, and a rect read against a
   freshly queried button is immune to that. */

(function () {
  function init() {
    var bar = document.querySelector('[data-sew-sticky-atc]');
    if (!bar || bar.dataset.sewReady === 'true') return;

    var proxyBtn = bar.querySelector('[data-sew-sticky-button]');
    var priceBox = bar.querySelector('[data-sew-sticky-price]');
    var variantLine = bar.querySelector('[data-sew-sticky-variant]');
    var thumb = bar.querySelector('[data-sew-sticky-thumb]');
    var infoContainer = document.querySelector('.product__info-container');

    // Quick-add buttons carry .quick-add__submit, so this only ever matches
    // the real button on the product page itself.
    function realButton() {
      return document.querySelector('.product-form__submit');
    }

    // The button this bar stands in for.
    function actionButton() {
      return realButton();
    }

    if (!realButton() || !proxyBtn) {
      bar.style.display = 'none';
      return;
    }
    bar.dataset.sewReady = 'true';

    function syncButton() {
      var btn = realButton();
      if (!btn) return;
      proxyBtn.disabled = btn.hasAttribute('disabled');
      var spans = btn.querySelectorAll('span');
      for (var i = 0; i < spans.length; i++) {
        if (!spans[i].classList.contains('hidden') && spans[i].textContent.trim()) {
          proxyBtn.textContent = spans[i].textContent.trim();
          break;
        }
      }
    }

    function syncPrice() {
      var p = infoContainer && infoContainer.querySelector('.price');
      if (!p || !priceBox) return;
      // outerHTML, not innerHTML - the .price wrapper carries the sale/sold-out
      // state classes the bar's own styles hang off.
      priceBox.innerHTML = p.outerHTML;
      var copy = priceBox.querySelector('.price');
      if (copy) copy.classList.remove('price--large');
    }

    // Dawn keeps the selected variant as JSON inside <variant-selects>.
    var lastVariantId = null;
    function syncVariant() {
      var el = document.querySelector('variant-selects [data-selected-variant]');
      if (!el) return;
      var v;
      try { v = JSON.parse(el.textContent); } catch (e) { return; }
      if (!v || v.id === lastVariantId) return;
      lastVariantId = v.id;
      if (variantLine) {
        var t = v.title && v.title !== 'Default Title' ? v.title.split(' / ').join(', ') : '';
        variantLine.textContent = t;
        variantLine.hidden = !t;
      }
      if (thumb && v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src;
        thumb.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      }
    }

    proxyBtn.addEventListener('click', function () {
      if (proxyBtn.disabled) return;
      var btn = realButton();
      if (btn) btn.click();
    });

    // Dawn replaces the buy-box markup on every variant change.
    if (infoContainer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        syncButton();
        syncPrice();
        syncVariant();
      }).observe(infoContainer, { subtree: true, childList: true, attributes: true });
    }

    // Chat and WhatsApp bubbles live in the same corner. Lift them clear
    // rather than letting them cover the button.
    var nudged = [];
    function nudgeFloatingWidgets(on) {
      try {
        if (on && !nudged.length) {
          var h = bar.offsetHeight || 68;
          var all = document.body.querySelectorAll('*');
          for (var i = 0; i < all.length; i++) {
            var el = all[i];
            if (el === bar || bar.contains(el)) continue;
            if (window.getComputedStyle(el).position !== 'fixed') continue;
            var r = el.getBoundingClientRect();
            if (r.width === 0 || r.width > 160) continue;
            if (window.innerHeight - r.bottom > 130) continue;
            nudged.push({ el: el, prev: el.style.transform });
            el.style.transition = 'transform .24s ease';
            el.style.transform = (el.style.transform || '') + ' translateY(-' + h + 'px)';
          }
        } else if (!on && nudged.length) {
          nudged.forEach(function (n) {
            n.el.style.transform = n.prev;
          });
          nudged = [];
        }
      } catch (e) {
        /* a third-party widget refusing to move is not worth breaking the page over */
      }
    }

    var shown = null;
    var ticking = false;

    function evaluate() {
      ticking = false;
      var btn = actionButton();
      if (!btn) return;
      var r = btn.getBoundingClientRect();
      // Gone means the main Add to cart button has left the viewport in either direction.
      var gone = r.bottom < 0 || r.top > window.innerHeight;
      if (gone === shown) return;
      shown = gone;
      bar.classList.toggle('is-visible', gone);
      document.body.classList.toggle('sew-sticky-on', gone);
      nudgeFloatingWidgets(gone);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    syncButton();
    syncPrice();
    syncVariant();
    evaluate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
